import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { CmsModules, CmsModuleShape } from 'containers/CmsPage/CmsModules';
import { CmsAction } from 'components/CmsPage/modules/CmsAction/CmsAction';
import { SimpleBanner } from '../SimpleBanner';
import { CMS_BANNER_THEME_TYPES } from '../constants';

export class CmsBanner extends PureComponent {
  handleCloseClick = event => {
    event.preventDefault();
    const { onBannerClose, onClose } = this.props;

    onBannerClose();
    if (onClose) {
      onClose();
    }
  };

  render() {
    const { action, modules, position = 'top', shouldShowBanner, theme } = this.props;

    if (!shouldShowBanner) {
      return null;
    }

    const banner = (
      <SimpleBanner className="CmsBanner" onClose={this.handleCloseClick} position={position} type={theme}>
        <CmsModules modules={modules} />
      </SimpleBanner>
    );

    if (action) {
      return (
        <CmsAction actionType={action.actionType} actionValue={action.actionValue} className={`CmsBanner--${theme}`}>
          {banner}
        </CmsAction>
      );
    }

    return banner;
  }
}

CmsBanner.propTypes = {
  action: PropTypes.shape({
    actionType: PropTypes.string.isRequired,
    actionValue: PropTypes.string,
  }),
  modules: PropTypes.arrayOf(CmsModuleShape).isRequired,
  onBannerClose: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  position: PropTypes.oneOf(['top', 'bottom']),
  shouldShowBanner: PropTypes.bool,
  theme: PropTypes.oneOf(CMS_BANNER_THEME_TYPES),
};
